'use strict';

intellidealerAppCoreModule.factory('achPaymentAgencies', function ($resource, appConfigurationService) {
  return {
    achPaymentAgencies: $resource(appConfigurationService.basePath + '/rest/customeraragencies/achPaymentAgencies/')
  };
});
